// extracted by mini-css-extract-plugin
export var text = "_o-0";